import './Icon_Bar_Chart.css';
 
function Icon_Bar_Chart() {
  return (
    <div className='icon-container-bar-chart'>
      <svg viewBox="0 0 24 24" className="bar-chart-svg">
        <path d="M3 3v18h18" />
        <path d="M18 17V9" />
        <path d="M13 17V5" />
        <path d="M8 17v-3" />
      </svg>
    </div>
  );
}
 
export default Icon_Bar_Chart;